import { render, staticRenderFns } from "./ImsStorage.vue?vue&type=template&id=607fba3f&scoped=true"
import script from "./ImsStorage.vue?vue&type=script&lang=js"
export * from "./ImsStorage.vue?vue&type=script&lang=js"
import style0 from "./ImsStorage.vue?vue&type=style&index=0&id=607fba3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607fba3f",
  null
  
)

export default component.exports